import { Record } from 'immutable';

export default class AssetRecord extends Record({
  id: -1,
  height: 0,
  width: 0,
  name: '',
  thumb_url: '',
  md5: '',
  asset_url: '',
  mime_type: '',
  upload_id: '',
  file_size: 0,
  selected: false,
  fileName: '',
}) {}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/records/AssetRecord.js